// src/components/snapshot/FreemiumSnapshotToolsGrid.tsx

import { useNavigate } from "react-router-dom";
import { SnapshotFreemiumCard, SnapshotCardConfig } from "./SnapshotFreemiumCard";

interface Props {
  cards: SnapshotCardConfig[];
}

export function FreemiumSnapshotToolsGrid({ cards }: Props) {
  const navigate = useNavigate();

  const enhancedCards = cards.map((card) => {
    if (card.id === "welcome" || card.id === "personalized_insights") {
      return {
        ...card,
        onPrimaryClick: () => navigate("/personalize"),
      };
    }
    if (card.id === "coaching") {
      return {
        ...card,
        onPrimaryClick: () => navigate("/coaching-center"),
      };
    }
    if (card.id === "premium_insights" || card.id === "custom_roadmap") {
      return {
        ...card,
        onPrimaryClick: () => navigate("/freemium/upgrade"),
      };
    }
    return card;
  });

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {enhancedCards.map((card) => (
        <SnapshotFreemiumCard key={card.id} {...card} />
      ))}
    </div>
  );
}